module.exports = __webpack_public_path__ + "img/banner.c75ab722.png";